"use client";

import Image from "next/image";
import { useTranslation } from "@/lib/i18n/context";

export function SocialProofSection() {
  const { t } = useTranslation();
  const s = t.landing.cover.socialProof;

  return (
    <section className="relative max-w-[1320px] mx-auto px-5 md:px-12 py-20 md:py-[120px] z-[2]">
      {/* Heading */}
      <div className="max-w-[760px] mx-auto text-left md:text-center">
        <div className="kicker-mono inline-flex items-center gap-2.5 mb-6">
          <span className="w-1.5 h-1.5 rounded-full bg-[var(--terracotta)]" /> {s.kicker}
        </div>
        <h2
          className="font-display text-[clamp(32px,4vw,52px)] leading-[1.05] tracking-[-0.02em] text-balance"
          style={{ fontWeight: 380 }}
        >
          {s.h2a} <em className="text-[var(--terracotta)] italic">{s.h2em}</em>
        </h2>
      </div>

      {/* Quotes — minimalist text cards */}
      <div className="mt-14 grid gap-6 md:grid-cols-2 max-w-[1040px] mx-auto">
        {s.quotes.map((q) => (
          <figure
            key={q.author + q.text.slice(0, 12)}
            className="flex flex-col rounded-2xl border border-[var(--rule)] bg-[var(--paper-2)]/30 p-8 md:p-10"
          >
            <span className="font-display text-[24px] md:text-[32px] leading-none text-[var(--terracotta)]/50" aria-hidden>“</span>
            <blockquote className="mt-1 font-display text-[clamp(18px,1.7vw,22px)] leading-[1.5] text-[var(--ink)] text-pretty">
              {q.text}
            </blockquote>
            <figcaption className="mt-5 font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--ink-soft)]">
              {q.author}
            </figcaption>
          </figure>
        ))}
      </div>

      {/* Founder note */}
      <div className="mt-20 max-w-[680px] mx-auto border-t border-[var(--hair)] pt-12">
        <div className="flex items-center gap-4 mb-6">
          <div
            className="relative h-14 w-14 shrink-0 overflow-hidden rounded-full border-[3px] border-[var(--paper)]"
            style={{ boxShadow: "0 6px 22px rgba(26,24,21,0.16)" }}
          >
            <Image
              src="/founder-tomaz.png"
              alt={s.founderSignature}
              fill
              sizes="56px"
              className="object-cover"
            />
          </div>
          <span className="kicker-mono inline-flex items-center gap-2.5">
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--terracotta)]" />
            {s.founderTitle}
          </span>
        </div>
        <div className="space-y-4 text-[17px] leading-[1.7] text-[var(--ink)]">
          {s.founderLetter.map((para, i) => (
            <p key={i} className="text-pretty">{para}</p>
          ))}
        </div>
        <p className="mt-6 font-display italic text-[19px] text-[var(--terracotta)]">{s.founderSignature}</p>
      </div>
    </section>
  );
}
